import { Variant } from "@/types/types.ts";

export const EAN_NOT_FOUND = "EAN_NOT_FOUND";

export function getEan(variant: Variant): string {
  const { consumerBarcodes } = variant;
  if (consumerBarcodes) {
    const { ean13 = [], upc12 = [], ean8 = [] } = consumerBarcodes;
    if (ean13.length === 0 && upc12.length === 0 && ean8.length === 0) {
      return EAN_NOT_FOUND;
    }
    return ean13[0] || upc12[0] || ean8[0] || EAN_NOT_FOUND;
  }
  return EAN_NOT_FOUND;
}
